import clsx from 'clsx'
import Image from 'next/image'

type Value = {
  id: number | string
  image?: {
    url: string
    height: number
    width: number
    alternativeText: string
  }
  title: string
  description: string
}
interface Props {
  title: string
  list: Value[]
  theme?: 'dark' | 'light' | 'purple'
}

function Benefits({ title, theme = 'dark', list }: Props): JSX.Element {
  return (
    <section
      className={clsx(
        theme === 'dark' || theme === 'purple'
          ? 'bg-blue-web-90 text-white'
          : 'text-blue-web-90'
      )}
    >
      <div className="container | py-10 lg:py-18">
        <h2
          className="font-heading font-medium text-3xl lg:text-5xl tracking-tight | max-w-col-9 mb-9 lg:mb-20"
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {list.map(value => {
            return (
              <div
                key={value.id}
                className={clsx(
                  theme === 'purple' || theme === 'light'
                    ? 'bg-blue-web-30 text-blue-web-90'
                    : 'bg-white text-blue-web-90',
                  'rounded-xl | py-10 px-6 lg:py-16 lg:px-10'
                )}
              >
                {value.image ? (
                  <Image
                    src={value.image.url}
                    height={value.image.height}
                    width={value.image.width}
                    alt={value.image.alternativeText}
                    className="mb-6 lg:mb-4"
                  />
                ) : null}
                <h3
                  className="font-heading font-semibold text-xl lg:text-2xl | mb-4"
                  dangerouslySetInnerHTML={{ __html: value.title }}
                />
                <div dangerouslySetInnerHTML={{ __html: value.description }} />
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Benefits
